import { bind } from 'decko';
import { css } from 'emotion';
import * as React from 'react';

import { Stars } from '../assets/Stars';

// #region Style
const label = css`
  color: #ffffff;
  position: absolute;
  top: 0;
  right: -30px;
  z-index: 1;

  width: 58px;
  border-radius: 30px;
  font-size: 8px;
  text-align: right;

  background-color: #72659f;
  padding-top: 3px;
  padding-bottom: 3px;
  padding-right: 7px;
`;

const wrapper = css`
  display: inline-block;
  position: relative;
  z-index: 0;
`;

const container = (className: string) => css`
  ${className}
  position: relative;
`;
// #endregion

interface IButtonProps {
  className: string;
  value: string;
  isDisabled: boolean;
  isMagic: boolean;
  secondary: boolean;
  onClick?(): void;
}

export class Button extends React.Component<IButtonProps> {
  public static defaultProps = {
    className: '',
    isDisabled: false,
    isMagic: false,
    secondary: false,
  };

  public render() {
    const { value, isMagic, className, isDisabled, secondary } = this.props;

    return (
      <div className={container(className)}>
        {isMagic && <Stars isTop />}
        <div className={wrapper}>
          <button disabled={isDisabled} onClick={this.onClick} className={this.computeButtonStyle(isMagic, secondary)}>
            {value}
          </button>
          {isMagic && (
            <div id="buttonLabel" className={label}>
              FREE
            </div>
          )}
        </div>
        {isMagic && <Stars />}
      </div>
    );
  }

  @bind
  private onClick() {
    const { onClick, isDisabled } = this.props;
    if (onClick && !isDisabled) {
      onClick();
    }
  }

  private computeButtonStyle(isMagic: boolean, secondary: boolean) {
    const color = isMagic || secondary ? '#72659F' : '#ffffff';
    const borderColor = isMagic ? '#72659F' : '#282828';
    const backgroundColor = isMagic || secondary ? '#ffffff' : '#72659F';
    const shadowColor = isMagic ? '#72659F' : '#590e51';

    return css`
      font-family: 'Nunito', sans-serif;
      font-weight: bold;
      min-width: 170px;
      height: 45px;
      border-radius: 3px;
      font-size: 18px;
      cursor: pointer;
      user-select: none;

      color: ${color};
      border: solid 1px ${borderColor};
      background-color: ${backgroundColor};
      box-shadow: 0px 2px 0 ${shadowColor};

      &[disabled] {
        color: #dbdbdb;
        border-color: #dbdbdb;
        background-color: #f1f2f2;
        box-shadow: 3px 3px #dbdbdb;
      }

      ${isMagic &&
        css`
          position: relative;
          z-index: 2;
        `}

      &:active {
        box-shadow: none;
        transform: translate(3px, 3px);

        & + #buttonLabel {
          transform: translate(3px, 3px);
        }
      }
    `;
  }
}
